module.exports = __webpack_public_path__ + "static/ForThePeople1-279d0f0f5042a79fa8ba14405e98b8c8.webp";